// Is this the Tesla's in-car browser? (William, 24 Sep.)
//
// The car's browser says it is plain Linux Chrome - no Tesla token in the user
// agent - so the only sign is its pixel ratio: 1.53 since the 2026.26 update,
// the same narrow window the site's Tesla scaling keys on (index.css). A
// Windows laptop at 150% reports exactly 1.5 and stays outside it.
//
// The device report stores each person's user agent; a visit from the car
// adds TESLA_MARK to it so the analytics can count the car on its own.

export const TESLA_MARK = "CHA-Tesla";

export function isTeslaBrowser(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  if (!/Linux/.test(ua) || /Android/.test(ua)) return false;
  return window.matchMedia("(min-resolution: 1.52dppx) and (max-resolution: 1.54dppx)").matches;
}
